import React, { useCallback, useEffect, useState } from 'react';
import { Buttons, CancelButton, Drawer, Form } from '~/components';
import ReadForm from '~/components/read-only/ReadForm';
import ReadTextbox from '~/components/read-only/ReadTextbox';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useDocumentTitle } from '~/hooks';
import { ErrorPage } from '~/routes/public/pages';

export default function ProjectGroupView({ projectGroupId, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const toast = useToast();

  const [query, setQuery] = useState({ isReady: false, data: null });
  const fetchData = useCallback(async () => {
    if (!projectGroupId) {
      setQuery({ isReady: true, data: {} });
      return;
    }

    try {
      const { data } = await api.www.workspaces(workspace.id).projectGroups(projectGroupId).get();
      setQuery({ isReady: true, data });
    } catch (error) {
      toast.error(error.message || 'There was a problem reading this project group. Please try again.');
    }
  }, [workspace.id, projectGroupId, api, toast]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const projectGroup = query?.data;

  const title = 'View Project Group';
  useDocumentTitle(title);

  if (!query.isReady) return null;
  if (!query.data) return <ErrorPage.NotFound publicSite={false} />;

  return (
    <Drawer isOpen title={title} onClose={onClose}>
      <ReadForm>
        <ReadForm.Section title="Project Group">
          <Form.Control>
            <ReadTextbox label="Name" value={projectGroup.name} />
          </Form.Control>

          {projectGroup.description && (
            <Form.Control>
              <ReadTextbox label="Description" value={projectGroup.description} />
            </Form.Control>
          )}
        </ReadForm.Section>

        <Drawer.Actions>
          <Buttons align="right">
            <CancelButton onClick={onClose}>Close</CancelButton>
          </Buttons>
        </Drawer.Actions>
      </ReadForm>
    </Drawer>
  );
}
